import { tasksKeys, RequestTypes } from '@core/react-query/features/tasks/tasks'
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { usePageableQuery } from '@core/react-query/hooks'
import { ITaskDraft, TaskDraft } from '@core/entities/task/TaskDraft'

const dataTransformer = ({ content }: PageResponse<ITaskDraft>) => {
  return content.map((task) => TaskDraft.new(task))
}

export const useGetDraftTasksInfinityQuery = (
  payload: RequestTypes['getDrafts'],
  options: UseInfiniteQueryOptions<
    PageResponse<ITaskDraft>,
    RequestErrorType,
    Array<TaskDraft>
  > = {},
) => {
  const draftTasksQuery = tasksKeys.draftTasks(payload)
  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options.enabled,
    queryKey: draftTasksQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<ITaskDraft>,
    RequestErrorType,
    Array<TaskDraft>
  >({
    ...infiniteQueryOptions,
    ...draftTasksQuery,
    ...options,
  })
}
